// Array of country objects for the flag dropdown.

// Here is the criteria for the plugin to support a given country/territory
// - It has an iso2 code: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
// - It has it's own country calling code (it is not a sub-region of another country): https://en.wikipedia.org/wiki/List_of_country_calling_codes
// - It has a flag in the region-flags project: https://github.com/behdad/region-flags/tree/gh-pages/png
// - It is supported by libphonenumber (it must be listed on this page): https://github.com/googlei18n/libphonenumber/blob/master/resources/ShortNumberMetadata.xml

import bugsnagClient from "@/utilities/bugsnag";

export async function getCountryByIp() {
    const response = await fetch('https://ip2c.org/s');
    const response_1 = await response.text();
    const result_1 = (response_1 || '').toString();
    if (!result_1 || result_1[0] !== '1') {
        throw new Error('unable to fetch the country');
    }
    return result_1.substr(2, 2);
}

export async function getAllCountries() {
  try{
      let response = await window.botClient.getCountries();
        if(response && response.countries ){
          console.log(response.countries.filter(x => x.iso !== "CS" || x.iso !== "AN"), "countries");
          
          return response.countries.filter(x => x.iso !== "CS" && x.iso !== "AN").map((country: any) => ({
            name: country.name,
            iso2: country.iso,
            dialCode: country.phone
          }));
        }
        else return [];
    
  }catch(error){
    console.error("get countries()", error);
    bugsnagClient.notify(error as any);
  }
}

// export default allCountries.map(([name, iso2, dialCode]: any) => ({
//   name,
//   iso2: iso2.toUpperCase(),
//   dialCode,
// }));